import { render, staticRenderFns } from "./CopyrightRow.vue?vue&type=template&id=b76b95bc&"
import script from "./CopyrightRow.vue?vue&type=script&lang=js&"
export * from "./CopyrightRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports